import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock3 } from "lucide-react";
import { api } from "../../../services/apiService";
import { paymentError } from "../../../components/payments/paymentUtils";
import { day, time } from "../../../components/schedule/scheduleUtils";
import { CheckoutHeader } from "../components/CheckoutHeader";

export function GuestBookingConfirmationPage() {
  const [params] = useSearchParams();
  const reference = params.get("reference");
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!reference) { setError("Booking reference is missing."); return undefined; }
    let active = true; let attempts = 0; let timer;
    const poll = async () => {
      try {
        const response = await api.get(`/checkout/guest-session/${encodeURIComponent(reference)}`);
        if (!active) return;
        setBooking(response.data);
        setError("");
        if (response.data.status !== "paid" && attempts++ < 10) timer = setTimeout(poll, 2500);
      } catch (err) { if (active) setError(paymentError(err, "We could not check confirmation yet.")); }
    };
    poll();
    return () => { active = false; clearTimeout(timer); };
  }, [reference]);

  const confirmed = booking?.status === "paid";
  return (
    <main className="checkout-wrap">
      <CheckoutHeader />
      <div className="ops-card auth-status" aria-live="polite">
        <div className={`auth-status-icon ${confirmed ? "" : "is-pending"}`}>{confirmed ? <CheckCircle2 size={26} /> : <Clock3 size={26} />}</div>
        <h1 className="ops-header-title">{confirmed ? "You're booked!" : "Confirming your payment"}</h1>
        {confirmed ? (
          <>
            <p>{booking.playerFirstName ? `${booking.playerFirstName} is` : "Your player is"} booked for <strong>{booking.session?.title}</strong>{booking.session?.startsAt ? <> on <strong>{day(booking.session.startsAt)}</strong> at <strong>{time(booking.session.startsAt)}</strong></> : null}. Reference <strong>{booking.reference}</strong>.</p>
            <p style={{ color: "var(--ops-muted)", fontSize: 13 }}>We've emailed your receipt along with a link to set up a password and manage this booking from your parent portal.</p>
          </>
        ) : (
          <p>{error || "Stripe has returned you safely. We're waiting for the secure confirmation before finalizing your booking — this usually takes only a moment."}</p>
        )}
        <div className="ops-form-actions"><Link to="/schedule" className="ops-button ops-button--primary">Back to schedule</Link><Link to="/login" className="ops-button ops-button--secondary">Sign in to your account</Link></div>
      </div>
    </main>
  );
}
